<script setup lang="ts">
import { computed, onMounted } from 'vue';

import Navbar from '@/components/Navbar.vue';

import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';

const checkoutFlow = useCheckoutFlow();
const { isLoading, fetchAndStoreWarehouseInfo } = useWarehouseInfo();

const isWarehouseLoading = computed(() => isLoading.value);

onMounted(async () => {
  await fetchAndStoreWarehouseInfo();
});
</script>

<template>
  <div
    class="page fill-height d-flex flex-column gap-6 pt-4"
    :class="checkoutFlow.step.value === CheckoutFlowStep.CheckoutCompletePage && 'bg-secondary'">
    <navbar
      :primary="checkoutFlow.step.value !== CheckoutFlowStep.CheckoutCompletePage ? true : false"
      class="px-4" />

    <div
      v-if="isWarehouseLoading"
      class="d-flex flex-column align-center justify-center gap-4 py-16 my-auto">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      <p class="text-body-1 text-grey">Loading warehouse information, please wait...</p>
    </div>

    <component v-else :is="checkoutFlow.getCurrentStepComponent(checkoutFlow.step)" />
  </div>
</template>
